export const RO_MONTHS = ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"];

export const eur = (v, digits = 0) =>
  `${(v || 0).toLocaleString("ro-RO", { minimumFractionDigits: digits, maximumFractionDigits: digits })} €`;

export const hrs = (v) => `${(v || 0).toLocaleString("ro-RO", { maximumFractionDigits: 1 })} h`;

export const pct = (v) => (v == null ? "—" : `${Number(v).toLocaleString("ro-RO", { maximumFractionDigits: 1 })}%`);

export const monthLabel = (key) => {
  if (!key) return "";
  const [y, m] = key.split("-");
  return `${RO_MONTHS[parseInt(m, 10) - 1]} ${y}`;
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${d}.${m}.${y}`;
};

export const STATUS = {
  ok: { label: "În buget", badge: "pio-badge-green", color: "#16a34a" },
  warning: { label: "Aproape de buget", badge: "pio-badge-amber", color: "#d97706" },
  over: { label: "Peste buget", badge: "pio-badge-red", color: "#dc2626" },
  no_budget: { label: "Fără buget", badge: "pio-badge-gray", color: "#94a3b8" },
};

export const currentYearStart = () => `${new Date().getFullYear()}-01`;

export const todayLocal = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const currentMonthLocal = () => todayLocal().slice(0, 7);

export const addMonths = (key, n) => {
  const [y, m] = key.split("-").map(Number);
  const t = y * 12 + (m - 1) + n;
  return `${Math.floor(t / 12)}-${String((t % 12) + 1).padStart(2, "0")}`;
};
